import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
//import bottom5RetailersData from '../data/bottom5.json';
import { isEmptyObject, getJCJPIDs } from "../../../utils/common/index";
import OthersBottom5RetailersView from "../../../views/rechargeSales/others/othersBottom5RetailersView";

const OthersBottom5Retailers = (props) => {
  const dispatch = useDispatch();
  const { getBottomFiveRetailer } = useSelector(
    (state) => state.rechargeSalesReducer
  );
  const { headerUnit } = useSelector((state) => state.homeReducer);

  let {
    url,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchBottomRetailers,
  } = props;

  let { level, jioPointId, partnerRT, retailerId } = getJCJPIDs(filterValue);

  const headers = {
    id: filterValue.orgId
      ? filterValue.orgId
      : filterValue.selectedRole.split(" - ")[2],
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    dispValue: headerUnit.unit,
    jprTypeName: "",
    section: props.section,
    moduleName: props.moduleName,
    isRedisActive: "YES",
    jioPointId,
    retailerId,
    level,
  };

  useEffect(() => {
    function fetchBottom5RetailersData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerFetchBottomRetailers(obj));
    }
    if (getBottomFiveRetailer && isEmptyObject(getBottomFiveRetailer.data) && partnerRT !== "DT") {
      fetchBottom5RetailersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchBottomRetailers,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit
  ]);


  return (
    <OthersBottom5RetailersView 
      partnerRT={partnerRT}
    />
  );
};

OthersBottom5Retailers.propTypes = {
  url: PropTypes.string,
  content: PropTypes.object,
};


export default OthersBottom5Retailers
